import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useCustomer from "./useCustomer";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const navigate = useNavigate();
  const { reset, handleSubmit, setErrors, editCustomerFields } = useCustomer();

  const { id } = useParams();

  useEffect(() => {
    axios.get("customers/" + id).then(res => {
      reset(res.data.customer);
    });

  }, []);

  const editCustomer = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    formData.append("_method", "PUT");

    axios.post('customers/' + id, formData)
      .then(function (res) {
        if (res.data.status) {
          swal('Customer has been updated successfully!', {
            icon: "success",
          });
          navigate("/customers/" + id);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit customer">
      <form className="form w-100 row" onSubmit={handleSubmit(editCustomer)}>
        {editCustomerFields}
        <div className="col-12">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}